import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8.32 21.97a.55.55 0 0 1-.26-.32c-.03-.15-.06.11.6-4.09.6-3.8.59-3.74.67-3.85.13-.17.11-.17 1.61-.18 1.32-.03 1.6-.03 2.19-.12 3.25-.45 5.26-2.36 5.96-5.66.04-.22.08-.41.09-.41 0-.01.07.04.15.1 1.03.78 1.38 2.22.99 4.14-.46 2.29-1.68 3.81-3.58 4.46-.81.28-1.49.39-2.69.42-.8.04-.82.04-1.05.19-.17.17-.16.14-.55 2.55-.27 1.7-.37 2.25-.41 2.35-.07.16-.21.3-.37.38l-.11.07H10c-1.29 0-1.62 0-1.68-.03m-4.5-2.23c-.19-.1-.32-.27-.32-.47C3.5 19 6.11 2.68 6.18 2.5c.09-.18.32-.37.5-.44L6.83 2h3.53c3.91 0 3.76 0 4.64.2 2.62.55 3.82 2.3 3.37 4.93-.5 2.93-1.98 4.67-4.5 5.3-.87.21-1.48.27-3.14.27-1.31 0-1.41.01-1.67.15-.26.15-.47.42-.56.75-.04.07-.27 1.47-.53 3.1a241 241 0 0 0-.47 3.02l-.03.06H5.69c-1.58 0-1.8 0-1.87-.04" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }